<script lang="ts" setup>
import Button from 'primevue/button'
import type { AutoTradeTrigger } from '@/services/auto-trade-trigger-service/types'

defineProps<{
  data: AutoTradeTrigger
  togglingId?: number | null
  deletingId?: number | null
}>()

const emit = defineEmits<{
  (e: 'toggle', id: number): void
  (e: 'remove', id: number): void
  (e: 'edit', data: AutoTradeTrigger): void
}>()
</script>

<template>
  <div class="flex gap-1 justify-center">
    <Button size="small" :icon="data.active ? 'pi pi-pause' : 'pi pi-play'" :loading="togglingId === data.id"
      @click="emit('toggle', data.id)" variant="text" rounded :severity="data.active ? 'warn' : 'success'"
      v-tooltip.top="data.active ? $t('deactivate') : $t('activate')" />
    <Button size="small" icon="pi pi-pencil" @click="emit('edit', data)" variant="text" rounded severity="success"
      v-tooltip.top="$t('edit')" />
    <Button size="small" icon="pi pi-trash" :loading="deletingId === data.id" @click="emit('remove', data.id)"
      variant="text" rounded severity="danger" v-tooltip.top="$t('delete')" />
  </div>
</template>
